<navigation-bar></navigation-bar>
<side-bar></side-bar>
<div class="main-container">
  <router-outlet></router-outlet>
</div>
